"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlexibleStakingAccountUserOffset = exports.getFlexibleStakingAccountUserOffsetV2 = exports.getFlexibleStakingAccountMintOffsetV2 = exports.getLockupStakingAccountUnlockedOffsetV2 = exports.getLockupStakingAccountUnlockedOffset = exports.getLockupStakingAccountOwnerOffsetV2 = exports.getLockupStakingAccountOwnerOffset = exports.getLockupStakingAccountMintOffsetV2 = exports.getLockupVaultMintOffsetV2 = exports.getWithdrawPositionMintOffsetV2 = exports.getWithdrawPositionClaimedOffsetV2 = exports.getWithdrawPositionClaimedOffset = exports.getWithdrawPositionUserOffsetV2 = exports.getWithdrawPositionUserOffset = void 0;
const constants_1 = require("./constants");
const getWithdrawPositionUserOffset = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE + // bump
        constants_1.U32_SIZE; // index
};
exports.getWithdrawPositionUserOffset = getWithdrawPositionUserOffset;
const getWithdrawPositionUserOffsetV2 = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE + // bump
        constants_1.PUBKEY_SIZE + // mint
        constants_1.U32_SIZE; // index
};
exports.getWithdrawPositionUserOffsetV2 = getWithdrawPositionUserOffsetV2;
const getWithdrawPositionClaimedOffset = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE + // bump
        constants_1.U32_SIZE + // index
        constants_1.PUBKEY_SIZE + // user
        constants_1.U64_SIZE + // amount
        constants_1.I64_SIZE; // start_delay_time
};
exports.getWithdrawPositionClaimedOffset = getWithdrawPositionClaimedOffset;
const getWithdrawPositionClaimedOffsetV2 = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE + // bump
        constants_1.PUBKEY_SIZE + // mint
        constants_1.U32_SIZE + // index
        constants_1.PUBKEY_SIZE + // user
        constants_1.U64_SIZE + // amount
        constants_1.I64_SIZE; // start_delay_time
};
exports.getWithdrawPositionClaimedOffsetV2 = getWithdrawPositionClaimedOffsetV2;
const getWithdrawPositionMintOffsetV2 = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE; // bump
};
exports.getWithdrawPositionMintOffsetV2 = getWithdrawPositionMintOffsetV2;
const getLockupVaultMintOffsetV2 = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE; // bump
};
exports.getLockupVaultMintOffsetV2 = getLockupVaultMintOffsetV2;
const getLockupStakingAccountMintOffsetV2 = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE; // bump
};
exports.getLockupStakingAccountMintOffsetV2 = getLockupStakingAccountMintOffsetV2;
const getLockupStakingAccountOwnerOffset = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE + // bump
        constants_1.U32_SIZE; // index
};
exports.getLockupStakingAccountOwnerOffset = getLockupStakingAccountOwnerOffset;
const getLockupStakingAccountOwnerOffsetV2 = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE + // bump
        constants_1.PUBKEY_SIZE + // mint
        constants_1.U32_SIZE; // index
};
exports.getLockupStakingAccountOwnerOffsetV2 = getLockupStakingAccountOwnerOffsetV2;
const getLockupStakingAccountUnlockedOffset = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE + // bump
        constants_1.U32_SIZE + // index
        constants_1.PUBKEY_SIZE + // owner
        constants_1.PUBKEY_SIZE + // lockup_vault
        constants_1.U16_SIZE + // committed_apy
        constants_1.U64_SIZE + // locked_amount
        constants_1.I64_SIZE; // locked_at
};
exports.getLockupStakingAccountUnlockedOffset = getLockupStakingAccountUnlockedOffset;
const getLockupStakingAccountUnlockedOffsetV2 = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE + // bump
        constants_1.PUBKEY_SIZE + // mint
        constants_1.U32_SIZE + // index
        constants_1.PUBKEY_SIZE + // owner
        constants_1.PUBKEY_SIZE + // lockup_vault
        constants_1.U16_SIZE + // committed_apy
        constants_1.U64_SIZE + // locked_amount
        constants_1.I64_SIZE; // locked_at
};
exports.getLockupStakingAccountUnlockedOffsetV2 = getLockupStakingAccountUnlockedOffsetV2;
const getFlexibleStakingAccountMintOffsetV2 = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE; // bump
};
exports.getFlexibleStakingAccountMintOffsetV2 = getFlexibleStakingAccountMintOffsetV2;
const getFlexibleStakingAccountUserOffsetV2 = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE + // bump
        constants_1.PUBKEY_SIZE; // mint
};
exports.getFlexibleStakingAccountUserOffsetV2 = getFlexibleStakingAccountUserOffsetV2;
const getFlexibleStakingAccountUserOffset = () => {
    return constants_1.DISCRIMINATOR_SIZE + // Discriminator
        constants_1.U8_SIZE; // bump
};
exports.getFlexibleStakingAccountUserOffset = getFlexibleStakingAccountUserOffset;
